var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteTick = function SvgWhiteTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.967,
    height: 48.675,
    viewBox: "0 0 48.967 48.675",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10654",
    "data-name": "Path 10654",
    d: "M53.093,32.57a8.068,8.068,0,0,1,0-6.164l.272-.649a8.117,8.117,0,0,0-4.405-10.6l-.6-.27a7.94,7.94,0,0,1-4.405-4.38l-.218-.541a8.307,8.307,0,0,0-10.714-4.38l-.544.216a8.343,8.343,0,0,1-6.255,0l-.489-.216a8.229,8.229,0,0,0-10.606,4.434l-.218.433a7.94,7.94,0,0,1-4.405,4.38l-.489.216a8.137,8.137,0,0,0-4.351,10.6l.218.487a8.068,8.068,0,0,1,0,6.164l-.218.595a7.994,7.994,0,0,0,4.405,10.544l.544.216a7.94,7.94,0,0,1,4.405,4.38l.272.595A8.143,8.143,0,0,0,25.9,53.063l.6-.27a8.343,8.343,0,0,1,6.255,0l.489.216a8.2,8.2,0,0,0,10.66-4.38l.218-.433a7.94,7.94,0,0,1,4.405-4.38l.435-.162a8.053,8.053,0,0,0,4.405-10.6ZM27.2,39.87h0L16.6,31l3.263-3.839,6.744,5.677L38.517,18.782l3.861,3.244L27.2,39.87Z",
    transform: "translate(-5.033 -4.988)",
    fill: "#f9f9f9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiteTick.2a58cbc6.svg";
export { ForwardRef as ReactComponent };